import React, { useMemo } from "react";
import { styled, css } from "styled-components";
import { Button } from "../Button";
const BannerWrapper = styled.div `
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const BannerImageContainer = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  align-item: flex-start;
  img {
    max-width: 100%;
    object-fit: cover;
  }
`;
const BannerOverlayLink = styled.a `
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 71.15%
  );
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
`;
const BannerOverlayOnClick = styled.div `
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 71.15%
  );
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  cursor: pointer;
`;
const BannerOverlay = styled.span `
  ${(hideGradient) => hideGradient === undefined &&
    css `
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.8) 71.15%
      );
    `};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
`;
const BannerAction = styled.span `
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  padding: 0 20px;
`;
const BannerMessage = styled.span `
  color: #ff0033;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  width: 100%;
  user-select: none;
  ${({ hasLabel }) => hasLabel &&
    css `
      color: #fff;
    `}
  }
`;
const BannerButtonWrapper = styled.span `
  clear: both;
  width: 100%;
  padding-top: 8px;
  display: inline-block;
  bottom: 16px;
`;
const BannerDiscount = styled.span `
  position: absolute;
  top: 8px;
  right: 8px;
`;
export const Banner = ({ enableClickEverywhere = false, message, target, image, discount, label, }) => {
    const alt = image.alt ? image.alt : message;
    const BannerContent = useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement(BannerAction, null,
            React.createElement(BannerMessage, { hasLabel: !!label }, message),
            label && target && (React.createElement(BannerButtonWrapper, null,
                React.createElement(Button, { size: "large", href: typeof target === "string" ? target : undefined, onClick: typeof target !== "string" && !enableClickEverywhere
                        ? target
                        : undefined }, label)))),
        discount && (React.createElement(BannerDiscount, null,
            React.createElement("svg", { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M58.3313 24.9599C58.5142 25.5085 59.4285 26.4228 60.3427 27.1542C61.9907 28.5257 63.5427 29.9885 63.4536 32C63.4536 34.1028 61.8079 35.4742 60.2536 36.8457C59.4307 37.5748 58.425 38.3977 58.2422 39.0377C58.0593 39.7691 58.5165 41.0491 58.8822 42.1462C59.5199 44.0639 60.2536 46.0777 59.2456 47.8148C58.2399 49.5519 56.137 50.0091 54.1256 50.3748C52.937 50.5577 51.657 50.8319 51.1999 51.2891C50.7427 51.7462 50.4685 53.0262 50.2856 54.2148C49.9199 56.2285 49.4627 58.3291 47.7256 59.3371C45.9885 60.3428 43.8856 59.6114 42.057 58.9714C40.8707 58.6057 39.5907 58.1485 38.9507 58.3314C38.4022 58.5142 37.4879 59.4285 36.7565 60.3428C35.385 61.8971 34.0136 63.5428 31.9107 63.5428C29.8079 63.5428 28.4365 61.8971 27.065 60.3428C26.3336 59.5199 25.5107 58.5142 24.8707 58.3314C24.2307 58.1508 22.9507 58.6079 21.8536 58.9691C19.9336 59.6091 17.9222 60.3405 16.185 59.3348C14.4479 58.3291 13.9907 56.2262 13.625 54.2148C13.4422 53.0262 13.1679 51.7462 12.7107 51.2891C12.2536 50.8319 10.9736 50.5577 9.78503 50.3748C7.77132 50.0068 5.67075 49.5497 4.66274 47.8148C3.65703 46.0777 4.38846 43.9748 5.02846 42.1462C5.39417 40.9599 5.85132 39.6799 5.66846 39.0399C5.4856 38.4914 4.57132 37.5771 3.65703 36.8457C2.10275 35.4742 0.457031 34.0114 0.457031 32C0.457031 29.8971 2.10275 28.5257 3.65703 27.1542C4.47989 26.4251 5.4856 25.6 5.66846 24.9622C5.85132 24.2308 5.39417 22.9508 5.02846 21.8537C4.39075 19.9337 3.65703 17.9222 4.66503 16.1851C5.67074 14.448 7.7736 13.9908 9.78503 13.6251C10.9736 13.4422 12.2536 13.1679 12.7107 12.7108C13.1679 12.2537 13.4422 10.9737 13.625 9.78509C13.9907 7.77138 14.4479 5.67081 16.185 4.66281C17.9222 3.65709 19.9336 4.38852 21.8536 5.02852C23.0399 5.39424 24.3199 5.85138 24.9599 5.66852C25.5085 5.48566 26.4227 4.57138 27.1542 3.65709C28.5256 2.10281 29.897 0.457092 31.9999 0.457092C34.1027 0.457092 35.4742 2.10281 36.8456 3.65709C37.5747 4.47995 38.3999 5.48566 39.0376 5.66852C39.769 5.85138 41.049 5.39424 42.1462 5.02852C44.0662 4.39081 46.0776 3.65709 47.8147 4.66509C49.5519 5.67081 50.009 7.77366 50.3747 9.78509C50.5576 10.9737 50.8319 12.2537 51.289 12.7108C51.7462 13.1679 53.0262 13.4422 54.2147 13.6251C56.2285 13.9908 58.329 14.448 59.337 16.1851C60.3427 17.92 59.6113 20.0228 58.9713 21.8514C58.6056 23.04 58.1485 24.32 58.3313 24.9599Z", fill: "#C31230" }),
                React.createElement("path", { d: "M31.5426 25.5084C31.5426 22.3999 29.2569 20.0228 25.7826 20.0228C22.3084 20.0228 20.1141 22.4867 20.1141 25.5084C20.1141 28.5255 22.3084 30.9941 25.7826 30.9941C29.2569 30.9941 31.5426 28.5255 31.5426 25.5084ZM23.5884 25.5084C23.5884 23.8604 24.5026 23.0399 25.7826 23.0399C27.0604 23.0399 28.0684 23.8604 28.0684 25.5084C28.0684 27.0604 27.0604 27.9747 25.7826 27.9747C24.5026 27.977 23.5884 27.0627 23.5884 25.5061V25.5084ZM38.2169 31.6341C34.7426 31.6341 32.4569 34.1026 32.4569 37.1198C32.4569 40.1392 34.6512 42.6054 38.2169 42.6054C41.6912 42.6054 43.9769 40.2283 43.9769 37.1198C43.8855 34.1026 41.6912 31.6341 38.2169 31.6341ZM38.2169 39.5883C36.9392 39.5883 36.0249 38.7677 36.0249 37.1198C36.0249 35.4741 36.9392 34.6535 38.2192 34.6535C39.4969 34.6535 40.4112 35.4763 40.4112 37.122C40.4112 38.7655 39.4969 39.5906 38.2169 39.5906V39.5883ZM37.5792 20.297L23.5884 42.2397H26.4204L40.5026 20.297H37.5792Z", fill: "white" })))))), [discount, enableClickEverywhere, label, message, target]);
    const bannerOverlay = useMemo(() => {
        if ((!label || enableClickEverywhere) && target) {
            return typeof target === "string" ? (React.createElement(BannerOverlayLink, { href: target }, BannerContent)) : (React.createElement(BannerOverlayOnClick, { onClick: target }, BannerContent));
        }
        return null;
    }, [BannerContent, enableClickEverywhere, label, target]);
    return (React.createElement(BannerWrapper, null,
        React.createElement(React.Fragment, null,
            image && (React.createElement(BannerImageContainer, null,
                React.createElement("img", { src: image.src, alt: alt }))),
            label || (!label && !target) ? (React.createElement(BannerOverlay, { hideGradient: (!label || enableClickEverywhere) && target !== undefined }, BannerContent)) : null,
            bannerOverlay)));
};
export default Banner;
//# sourceMappingURL=Banner.js.map